<div class="d-flex flex-column justify-content-between w-100 pb-2">
    <div class="d-flex w-100 flex-column">
        <form class="input-group">
            <input #hsTimeseriesTitle readonly type="text" class="form-control" id="hs-timeseries-title"
                [value]="fileTitle" [ngClass]="{'is-invalid': !selectedString}">
            <button type="button" (click)="selectDateString($event)" class="btn btn-sm btn-primary">{{'COMMON.select' |
                translateHs }}</button>
        </form>
        <label for="hs-timeseries-title" class="text-danger small pt-1"
            [hidden]="selectedString">{{'ADDDATA.FILE.highlightAndSelect' | translateHs }}</label>

    </div>

    <div ngbAccordion #acc="ngbAccordion" class="my-2" [hidden]="!formVisible">
        <div ngbAccordionItem [collapsed]="false" id="hs-timeseries-acc">
            <div ngbAccordionHeader>
                <button ngbAccordionButton class="accordion-button text-black-50">{{'ADDDATA.FILE.selectedString' |
                    translateHs }}: <span class="text-black ps-1">{{selectedString}}</span></button>
            </div>
            <div ngbAccordionCollapse>
                <form ngbAccordionBody [formGroup]="form" class="d-flex flex-column">
                    <ng-template>
                        <div class="form-floating mt-2 flex-fill"
                            [ngClass]="{'verification-pending': !form.get('verified').value}">
                            <input formControlName="regex" type="text" class="form-control form-control-sm"
                                id="hs-timeseries-regex" [ngClass]="{'is-valid': form.get('verified').value}">
                            <label for="hs-timeseries-regex">{{'ADDDATA.FILE.inferredRegex' |
                                translateHs }}</label>
                        </div>
                        <div class="d-flex justify-content-between">
                            <p class="text-black-50 small pt-1">{{'ADDDATA.FILE.verifyInferredRegex' |
                                translateHs }}</p>
                            <button type="button" (click)="verifyInputs()"
                                class="btn btn-sm btn-primary m-2 w-25">{{'COMMON.confirm' |
                                translateHs }}</button>
                        </div>
                    </ng-template>
                </form>
            </div>
        </div>
    </div>
</div>
